import { Injectable } from "@angular/core";
import * as io from "socket.io-client";
import { AlertService } from "./alert.service";
import { Globals } from "@foh/globals";
import { Observable, of } from "rxjs";
import { QueueNotificationService } from "./queueNotification.service";

@Injectable({
  providedIn: "root",
})
export class QueueSocketsService {
  public socket;
  public socketConnected: boolean;
  public interval = null;
  public eventsBinded: boolean = false;
  public channels: string[] = [];

  constructor(
    private globals: Globals,
    private alertService: AlertService,
    private queueNotificationService: QueueNotificationService
  ) {
    this.socketConnected = false;
  }
  initializeChannels(refcode: string) {
    this.channels = [`queue-notification-${refcode}`, "queue-reminder"];
  }

  connect() {
    var mainObservable = Observable.create((observer) => {
      this.connectToNodeServer();
      observer.next(this.socketConnected);
      observer.complete();
    });
    return mainObservable;
  }

  connectToNodeServer() {
    if (this.socket) {
      this.socket.destroy();
      delete this.socket;
      this.socket = null;
    }
    // console.log("QueueSocketsService: Connecting to", this.globals.URL_SOCKET);
    this.socket = io(this.globals.URL_SOCKET, {
      transports: ["websocket"],
      secure: true,
      reconnection: false,
    });
    this.socket.on("connect", () => {
      // console.log("QueueSocketsService: Connected!");
      this.socketConnected = true;
      this.registerToChannels();
      this.bindEvents();
    });
    this.socket.on("disconnect", () => {
      // console.log("QueueSocketsService: Disconnected!");
      this.socketConnected = false;
      this.retryConnection();
    });
    this.socket.on("connect_error", (err) => {
      // console.error("QueueSocketsService: Connect error", err);
      this.socket.disconnect();
      this.socketConnected = false;
    });
    this.socket.on("connect_timeout", () => {
      // console.error("QueueSocketsService: Connect timeout");
      this.socketConnected = false;
      this.retryConnection();
    });
    this.socket.on("error", (err) => {
      // console.error("QueueSocketsService: Socket error", err);
      this.socketConnected = false;
    });
  }

  registerToChannels() {
    if (!this.socketConnected) {
      return;
    }
    this.socket.emit("register-socket", {
      tokens: this.channels,
      platform: "Web",
    });
  }

  retryConnection() {
    this.interval = window.setInterval(() => {
      if (this.socketConnected) {
        clearInterval(this.interval);
        this.interval = null;
        return;
      }
      //this.connect().subscribe();
      this.connectToNodeServer();
    }, 3000);
  }

  bindEvents() {
    if (!this.socketConnected || this.eventsBinded) {
      return;
    }
    const refcodeToken = this.channels.find((c) =>
      c.startsWith("queue-notification-")
    );
    if (refcodeToken) {
      this.socket.on(refcodeToken, (event) => {
        const reservation = JSON.parse(event.reservation);
        this.queueNotificationService.update(reservation);
      });
    }

    this.eventsBinded = true;
  }

  listen(eventKey: string): Observable<any> {
    return new Observable((observer) => {
      if (!this.socket || !this.socketConnected) {
        console.warn("Socket not ready. Cannot subscribe to:", eventKey);
        observer.complete();
        return;
      }

      const handler = (data: any) => {
        try {
          const parsed = typeof data === "string" ? JSON.parse(data) : data;
          observer.next(parsed);
        } catch (e) {
          observer.error(e);
        }
      };

      this.socket.on(eventKey, handler);

      return () => {
        this.socket.off(eventKey, handler);
      };
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socketConnected = false;
    }
  }
}
